var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('div',[_vm._v("View "+_vm._s(_vm.$route.params))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }